<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <Popover class="inline-block" v-slot="{ open }">
    <PopoverButton
        :class="[open ? 'text-gray-900' : 'text-gray-500', 'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-3 mb-3']">
      <div class="inline-block">
        <span class="relative inline-block mr-3">
          <img class="h-16 w-16 rounded-md" :src="this.iconPath" alt="">

          <span v-if="this.color"
                :class="[this.color,'absolute top-0 right-0 block h-4 w-4 transform -translate-y-1/2 translate-x-1/2 rounded-full ring-2 ring-white']"></span>

        </span>
        <p class="text-xs w-16 truncate">{{ this.organizationName }}</p>
      </div>
    </PopoverButton>
    <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1"
                enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150"
                leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
      <PopoverPanel class="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-md sm:px-0">
        <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
            <a :href="this.meetupLink" v-if="this.meetup"
               class="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50 transition ease-in-out duration-150">
              <component :is="Chat" class="flex-shrink-0 h-6 w-6 text-indigo-600" aria-hidden="true"/>
              <div class="ml-4">
                <p class="text-base font-medium text-gray-900">
                  {{ this.meetup.name }}
                </p>
                <p class="mt-1 text-sm text-gray-500">
                  {{ this.meetup.description }}
                </p>
                <p class="mt-1 text-sm text-gray-500">
                  {{ this.meetup.user_time_string }}
                </p>
              </div>
            </a>
            <!-- solutions -->
            <a :href="this.organizationLocalUrl"
               class="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50 transition ease-in-out duration-150">
              <component :is="Library" class="flex-shrink-0 h-6 w-6 text-indigo-600" aria-hidden="true"/>
              <div class="ml-4">
                <p class="text-base font-medium text-gray-900">
                  {{ this.organizationName }}
                </p>
                <p class="mt-1 text-sm text-gray-500">
                  {{ this.organizationDescription }}
                </p>
              </div>
            </a>
            <a v-if="this.nextSession && this.nextSession.title" :href="this.nextSession.url ?? '#'"
               class="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50 transition ease-in-out duration-150">
              <component :is="Presentation" class="flex-shrink-0 h-6 w-6 text-indigo-600" aria-hidden="true"/>
              <div class="ml-4">
                <p class="text-base font-medium text-gray-900">
                  Presentation
                </p>
                <p class="mt-1 text-sm text-gray-500">
                  {{ this.nextSession.title }}
                </p>
                <p class="mt-1 text-sm text-gray-500">
                  {{ this.nextSession.time }}
                </p>
              </div>
            </a>
          </div>
          <div class="px-5 py-5 bg-gray-50 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8">

            <a :href="this.organizationLocalUrl"
               class="-m-3 p-3 flex items-center rounded-md text-base font-medium text-gray-900 hover:bg-gray-100 transition ease-in-out duration-150">
              <component :is="Globe" class="flex-shrink-0 h-6 w-6 text-gray-400"
                         aria-hidden="true"/>
              <span class="ml-3">EME</span>
            </a>

            <a :href="this.organizationUrl"
               class="-m-3 p-3 flex items-center rounded-md text-base font-medium text-gray-900 hover:bg-gray-100 transition ease-in-out duration-150">
              <component :is="Globe" class="flex-shrink-0 h-6 w-6 text-gray-400"
                         aria-hidden="true"/>
              <span class="ml-3">WEB</span>
            </a>

          </div>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import {
  ChartBarIcon,
  CursorClickIcon,
  PhoneIcon,
  PlayIcon,
  RefreshIcon,
  ShieldCheckIcon,
  ViewGridIcon,
  GlobeIcon,
  LibraryIcon,
  PresentationChartLineIcon,
  ChatIcon,
} from '@heroicons/vue/outline'


export default {
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronDownIcon,
    PresentationChartLineIcon,
    ChatIcon,
  },
  setup(props) {

    const Phone = PhoneIcon;
    const Globe = GlobeIcon;
    const Library = LibraryIcon;
    const Chat = ChatIcon;
    const Presentation = PresentationChartLineIcon;
    //const name = props.name;
    //const iconPath = props.iconPath;
    return {
      Phone,
      Globe,
      Library,
      Presentation,
      Chat,
    }
  },
  computed: {
    color() {
      /*
      if (this.isMeetupInProgress || this.isSessionInProgress) {
        return 'bg-green-400';
      }
      */
      if (this.isMeetupInProgress) {
        return 'bg-green-400';
      }
      return this.meetup ? 'bg-gray-400' : '';
    },
    meetupLink() {
      return this.isMeetupInProgress && this.meetup ? this.meetup.location : this.organizationLocalUrl + '/meetups';
    }
  },
  props: {
    organizationName: {
      type: String,
      required: true
    },
    organizationDescription: {
      type: String,
      required: true
    },
    organizationUrl: {
      type: String,
      required: true
    },
    organizationLocalUrl: {
      type: String,
      required: true
    },
    /*next: {
      type: Object,
      required: false,
    },*/
    iconPath: {
      type: String,
      required: true
    },
    meetup: {
      type: Object,
      required: false,
    },
    isMeetupInProgress: {
      type: Boolean,
      required: false,
    },
    nextSession: {
      type: Object,
      required: false,
    },
    isSessionInProgress: {
      type: Boolean,
      required: false,
    },
    rand: {
      type: Number,
      required: false,
    }

  }
}
</script>